(function(){
  var openBtn=document.querySelector('[data-menu-open]'),dlg=document.getElementById('mnav');
  if(openBtn&&dlg){
    var closeBtn=dlg.querySelector('[data-menu-close]');
    var fx=function(){return Array.prototype.slice.call(dlg.querySelectorAll('a[href],button:not([disabled])'));};
    var shut=function(){dlg.classList.remove('is-open');dlg.hidden=true;openBtn.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');};
    var open=function(){dlg.hidden=false;dlg.classList.add('is-open');openBtn.setAttribute('aria-expanded','true');document.body.classList.add('menu-open');closeBtn.focus();};
    var close=function(){shut();openBtn.focus();};
    openBtn.addEventListener('click',open);closeBtn.addEventListener('click',close);
    dlg.querySelectorAll('nav a').forEach(function(a){a.addEventListener('click',shut);});
    document.addEventListener('keydown',function(e){
      if(!dlg.classList.contains('is-open'))return;
      if(e.key==='Escape'){e.preventDefault();close();return;}
      if(e.key!=='Tab')return;var f=fx();if(!f.length)return;var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}
    });
  }
  document.querySelectorAll('[data-finder]').forEach(function(form){
    var mk=form.querySelector('[data-make]'),en=form.querySelector('[data-engine]'),st=document.getElementById(form.getAttribute('data-status'));
    if(!mk||!en)return;var all=Array.prototype.slice.call(en.querySelectorAll('option[data-makes]'));var ph=en.querySelector('option:not([data-makes])');
    var sync=function(){var m=mk.value;all.forEach(function(o){var ok=!!m&&(','+o.getAttribute('data-makes')+',').indexOf(','+m+',')>-1;o.hidden=!ok;o.disabled=!ok;});
      if(en.selectedOptions[0]&&en.selectedOptions[0].disabled)en.value='';en.disabled=!m;if(ph)ph.textContent=m?'Select engine':'Select a make first';
      var n=all.filter(function(o){return !o.disabled;}).length;if(st)st.textContent=m?n+' verified '+(n===1?'engine':'engines')+' for '+m+'.':'';};
    mk.addEventListener('change',sync);sync();
    form.addEventListener('submit',function(e){
      if(!mk.value){e.preventDefault();if(st)st.textContent='Select a make to see compatible parts.';mk.focus();return;}
      if(!en.value){e.preventDefault();if(st)st.textContent='Select an engine to narrow the results.';en.focus();}
    });
  });
  document.querySelectorAll('form.nl').forEach(function(form){
    var em=form.querySelector('input[type=email]'),cb=form.querySelector('input[type=checkbox]'),st=form.querySelector('[data-nl-status]');
    if(!em||!st)return;
    form.addEventListener('submit',function(e){
      if(!em.value.trim()||!em.checkValidity()){e.preventDefault();em.setAttribute('aria-invalid','true');st.className='nl__st nl__st--err';st.textContent='Please enter a valid email address.';em.focus();return;}
      if(cb&&!cb.checked){e.preventDefault();st.className='nl__st nl__st--err';st.textContent='Tick the box to confirm you would like OVRDRV updates.';cb.focus();return;}
      em.removeAttribute('aria-invalid');st.className='nl__st';st.textContent='Signing you up\u2026';
    });
  });

  /* Search (1 Oct): highlight matched words in result cards + suggestions while typing. */
  var esc=function(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');};
  var hl=function(els,q){
    var ts=q.toLowerCase().split(/\s+/).filter(function(x){return x.length>1;}).map(esc).sort(function(a,b){return b.length-a.length;});
    if(!ts.length)return;var re=new RegExp('('+ts.join('|')+')','gi');
    Array.prototype.forEach.call(els,function(el){
      if(el.querySelector('mark'))return;var parts=el.textContent.split(re);if(parts.length<2)return;
      var fr=document.createDocumentFragment();
      parts.forEach(function(p,i){if(!p)return;if(i%2){var m=document.createElement('mark');m.className='hl';m.textContent=p;fr.appendChild(m);}else fr.appendChild(document.createTextNode(p));});
      el.textContent='';el.appendChild(fr);
    });
  };
  var grid=document.querySelector('.srp__g[data-hl]');
  if(grid)hl(grid.querySelectorAll('.pname,.papp'),grid.getAttribute('data-hl'));
  document.querySelectorAll('.sfm__i').forEach(function(inp){
    var box=document.createElement('div');box.className='sgg';box.id=inp.id+'-sgg';box.hidden=true;inp.parentNode.appendChild(box);
    inp.setAttribute('role','combobox');inp.setAttribute('aria-autocomplete','list');inp.setAttribute('aria-expanded','false');inp.setAttribute('aria-controls',box.id);
    var tm,ctl,act=-1,opts=function(){return box.querySelectorAll('[role=option]');};
    var close=function(){box.hidden=true;inp.setAttribute('aria-expanded','false');inp.removeAttribute('aria-activedescendant');act=-1;};
    var setAct=function(n){var o=opts();if(!o.length)return;act=(n+o.length)%o.length;Array.prototype.forEach.call(o,function(x,j){x.setAttribute('aria-selected',j===act?'true':'false');});inp.setAttribute('aria-activedescendant',o[act].id);};
    inp.addEventListener('input',function(){
      clearTimeout(tm);var q=inp.value.trim();if(q.length<2){close();return;}
      tm=setTimeout(function(){
        if(ctl&&ctl.abort)ctl.abort();ctl=window.AbortController?new AbortController():null;
        fetch('/search?type=product&options%5Bprefix%5D=last&section_id=ovrdrv-search-suggest&q='+encodeURIComponent(q),ctl?{signal:ctl.signal}:{})
          .then(function(r){return r.ok?r.text():'';})
          .then(function(h){
            if(inp.value.trim()!==q)return;var d=document.createElement('div');d.innerHTML=h;var s=d.querySelector('.sgg__in');if(!s){close();return;}
            box.innerHTML='';box.appendChild(s);Array.prototype.forEach.call(opts(),function(o,j){o.id=box.id+'-o'+j;o.setAttribute('aria-selected','false');});
            hl(box.querySelectorAll('.sgg__n'),q);box.hidden=false;inp.setAttribute('aria-expanded','true');act=-1;
          }).catch(function(){});
      },220);
    });
    inp.addEventListener('keydown',function(e){
      if(box.hidden)return;
      if(e.key==='ArrowDown'){e.preventDefault();setAct(act+1);}
      else if(e.key==='ArrowUp'){e.preventDefault();setAct(act-1);}
      else if(e.key==='Enter'&&act>-1){e.preventDefault();window.location.href=opts()[act].href;}
      else if(e.key==='Escape'){e.preventDefault();close();}
    });
    document.addEventListener('click',function(e){if(!inp.parentNode.contains(e.target))close();});
  });
})();
